import { render, staticRenderFns } from "./FieldThumbnailGallery.vue?vue&type=template&id=07240cb4&"
import script from "./FieldThumbnailGallery.vue?vue&type=script&lang=js&"
export * from "./FieldThumbnailGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports